import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import './Modal.scss';
import { testIds } from '../../../constants/testId';

const ModalBox = (props) => {
  const { open, handleClose, titleName, titleMsg, disableBackdropClick, className, maxWidth } =
    props;
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableBackdropClick={disableBackdropClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth={maxWidth}>
      <div className={`modalcontent ${className && className}`}>
        <div className="close" onClick={handleClose} data-testid={testIds['modal-close']} />
        <div className="toppart">
          <div className="modalHeader">
            <h3 className="modaltitle">{titleName}</h3>
            {titleMsg && <h2 className="modalmsg">{titleMsg}</h2>}
          </div>
          <div className="modalinfo">{props.children}</div>
        </div>
      </div>
    </Dialog>
  );
};

export default ModalBox;

ModalBox.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  titleName: PropTypes.string,
  titleMsg: PropTypes.string,
  disableBackdropClick: PropTypes.bool,
  children: PropTypes.object,
  className: PropTypes.string,
  maxWidth: PropTypes.string
};
